import { EventImpl } from '@fullcalendar/core/internal';
import { Box, Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';

const orderLimitsEvent = ({ event }: { event: EventImpl }) => {
  const startDateTime = DateTime.fromJSDate(event.start);
  const endDateTime = DateTime.fromJSDate(event.end);

  const startTimeLabel = startDateTime.toFormat('h:mm a');
  const endTimeLabel = endDateTime.toFormat('h:mm a');

  const durationMinutes = endDateTime.diff(startDateTime, 'minutes').minutes;
  const nextTimeSlotHasEvent =
    event.extendedProps?.nextTimeSlotHasEvent ?? false;

  return (
    <Stack data-testid={`OrderLimitsEvent.${event.id}`} overflow="hidden">
      {durationMinutes <= 30 || nextTimeSlotHasEvent ? (
        <Box ml={0.5}>
          <Typography noWrap fontWeight="bold">
            {`${event.title}, ${startTimeLabel}`}
          </Typography>
        </Box>
      ) : (
        <>
          <Box ml={0.5}>
            <Typography noWrap fontWeight="bold">
              {event.extendedProps.eventType === 'LocationHours'
                ? event.title
                : `${event.title}: ${
                    event.title === 'Value'
                      ? `$ ${event.extendedProps.kitchenThrottleValues.value}`
                      : event.extendedProps.kitchenThrottleValues.count
                  }`}
            </Typography>
          </Box>
          {!event.allDay && !nextTimeSlotHasEvent && endDateTime.isValid && (
            <Box ml={0.5}>
              <Typography noWrap>
                {`${startTimeLabel} - ${endTimeLabel}`}
              </Typography>
            </Box>
          )}
        </>
      )}
    </Stack>
  );
};

export default orderLimitsEvent;
